import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const Container = styled.a`
  ${tw`hidden md:block p-2 text-dark-gray hover:text-button-blue transition-colors`}
`;
